import retrieveAdditionalSalesIcons from '@/shared/icons/retrieveAdditionalSalesIcons'
import { useDispatch, useSelector } from 'react-redux'
import { selectAdditionalSalesConfig } from '../../SubscriptionForm/SubscriptionFormSelectors'
import { useEffect } from 'react'
import { updateActiveTab, updateAdditionalSalesConfig } from '../../SubscriptionForm/SubscriptionFormSlice'
import { modulesConfig } from '@/containers/SubscriptionFormPageNew/config'

const useCreditBooster = country => {
  const dispatch = useDispatch()
  const { scrollToAdditionalSaleTab } = useSelector(selectAdditionalSalesConfig)
  const creditBoosterEnabled = modulesConfig[country]?.additionalSales?.creditBooster ?? true
  const ProviderOverrides = () => ({
    Svg: {
      style: () => ({
        marginRight: '0.45rem',
        width: '2rem',
        height: '2rem',
      }),
    },
  })

  const getIcon = iconName => {
    return retrieveAdditionalSalesIcons(iconName, 20, ProviderOverrides(), '#ED9542')
  }

  useEffect(() => {
    if (scrollToAdditionalSaleTab) {
      dispatch(updateActiveTab('additional-sales'))
      dispatch(updateAdditionalSalesConfig({ scrollToAdditionalSaleTab: false }))
    }
  }, [scrollToAdditionalSaleTab])

  return {
    getIcon,
    creditBoosterEnabled,
  }
}

export default useCreditBooster
